import { toast as sonnerToast, type ExternalToast } from 'sonner';

/**
 * Sonner toast convenience helpers. Use these instead of `import { toast } from 'sonner'` so that
 * (a) we have a single place to wire defaults (theme-aware via the <Toaster /> wrapper), and
 * (b) consumers get a typed, narrow API.
 */
export const toast = {
  success(title: string, opts?: ExternalToast): string | number {
    return sonnerToast.success(title, opts);
  },
  error(title: string, opts?: ExternalToast): string | number {
    return sonnerToast.error(title, opts);
  },
  info(title: string, opts?: ExternalToast): string | number {
    return sonnerToast.info(title, opts);
  },
  warning(title: string, opts?: ExternalToast): string | number {
    return sonnerToast.warning(title, opts);
  },
  /** Escape hatch when the four shapes above don't fit. */
  raw: sonnerToast,
};
